<!-- Making sure we don't have a shadow here, because we're now using multiple headers. -->
<!--
	TODO: refactor some things to ensure only a single header component is used!
		This is important because this component keeps in mind the device safe areas,
		and has some functionality that shouldn't be repeated. However, the difficult
		part here is that part of the header content is global, while other parts are
		page specific. The usage of the "portal" pattern could help us here to ensure
		that the global parts aren't re-rendered with each navigation, unless we test
		if this re-rendering has significant performance impact first, then decide?
		See https://intocare.atlassian.net/browse/ICP-16237
 -->
<ion-header class="ion-no-border">
	<ion-toolbar [color]="isOffline() ? 'warning' : 'secondary'">
		<ion-buttons slot="start">
			@if (isOffline()) {
				<ion-button (click)="isOfflineInfoDialogOpen.set(true)">
					<ion-icon name="cloud-offline-outline" size="small" slot="start" />
					<span class="icds-text-size-xs">{{ isOfflineDurationDisplay() }}</span>
				</ion-button>
			} @else {
				<ion-button>
					<ion-icon name="cloud-outline" size="small" slot="start" />
					<span class="icds-text-size-xs">{{ "appAlertBanner.onlineStatus.online" | translate }}</span>
				</ion-button>
			}
		</ion-buttons>
		@if (syncStatusInProgress()) {
			<ion-buttons slot="end">
				<ion-button (click)="onSyncStatusClick()">
					<ion-icon name="cloud-upload-outline" size="small" slot="end" />
					@if (syncStatusInProgressCount(); as count) {
						<span class="icds-text-size-xs">{{
							(count === 1 ? "appAlertBanner.syncStatus_one" : "appAlertBanner.syncStatus_more") | translate: { count }
						}}</span>
					}
				</ion-button>
			</ion-buttons>
		}
	</ion-toolbar>
</ion-header>
<icds-alert-dialog [dataMessage]="isOfflineInfoDialogMessage()" [(dataIsOpen)]="isOfflineInfoDialogOpen" />
